<template>
    <div class="wrapper">
        <div class="policy-container">
            <h1>Dorsett Controls</h1>
            <h2>SMS Terms & Conditions</h2>

            <section>
            <h3>Program Name</h3>
            <p>Operational Alerts</p>
            </section>

            <section>
            <h3>Program Description</h3>
            <p>
                By opting in, you agree to receive operational text messages related to your account, services, system status, and important service notifications. These messages are informational and transactional in nature and are not marketing messages.
            </p>
            </section>

            <section>
            <h3>Message Frequency</h3>
            <p>Message frequency varies based on account activity and service events.</p>
            </section>

            <section>
            <h3>Carrier Message &amp; Data Rates</h3>
            <p>Message and data rates may apply depending on your mobile carrier and plan.</p>
            </section>

            <section>
            <h3>Opt-Out Instructions</h3>
            <p>You may opt out of receiving text messages at any time by replying <strong>STOP</strong>. After opting out, you will no longer receive SMS messages unless you re-enroll.</p>
            </section>

            <section>
            <h3>Help Instructions</h3>
            <p>For assistance, reply <strong>HELP</strong> or contact us using the support information below.</p>
            </section>

            <section>
            <h3>Contact Information</h3>
            <p class="contact-block">
            <strong style="color:#003366">Dorsett Controls</strong><br />
            <span class="contact-row">
                <span class="contact-label">Phone:</span>
                <a class="contact-link" href="tel:+18553872232">855 DT SCADA (855-387-2232)</a>
            </span><br />
            <span class="contact-row">
                <span class="contact-label">Email:</span>
                <a class="contact-link" href="mailto:support@dorsettcontrols.com">support@dorsettcontrols.com</a>
            </span>
            </p>
            </section>

            <section>
        <h3>Privacy</h3>
        <p>
        Your mobile number will be used solely for operational communications and will not be shared or sold. For more information, please review our Privacy Policy at <a href="https://portal.dtscada.com/#/privacy-policy" class="contact-link">https://portal.dtscada.com/#/privacy-policy</a>.
        </p>
        </section>

        <footer>
        © Dorsett Controls. All rights reserved.
        </footer>

        </div>
    </div>

</template>

<script>
export default {
    name: "InfoscanSMSTermsAndConditions",
};
</script>

<style scoped>
.wrapper {
  background-color: #f5f5f5;
  min-height: 100vh;
}
.policy-container {
  background-color: #FFF;
  max-width: 900px;
  margin: 40px auto;
  padding: 0 20px;
  font-family: Arial, Helvetica, sans-serif;
  color: #333;
  line-height: 1.6;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

h1 {
  color: #003366;
  margin-bottom: 0;
}

h2 {
  color: #003366;
  margin-top: 5px;
  border-bottom: 2px solid #003366;
  padding-bottom: 10px;
}

.subtitle {
  font-size: 0.9em;
  font-weight: normal;
}

h3 {
  margin-top: 30px;
  color: #003366;
}

ul {
  margin-left: 20px;
}

footer {
  margin-top: 40px;
  padding-top: 15px;
  padding-bottom: 15px;
  border-top: 1px solid #ccc;
  font-size: 0.9em;
  color: #555;
  text-align: center;
}

.contact-block {
  margin: 0;
}

.contact-row {
  display: inline-block;
  margin-top: 4px;
}

.contact-label {
  font-weight: 600;
  margin-right: 6px;
  color: #003366;
}

.contact-link {
  color: inherit;
  text-decoration: underline;
  text-underline-offset: 2px;
}
</style>
